import * as React from 'react';
import { Provider } from 'react-redux';
import { applyMiddleware, combineReducers, createStore, Store } from 'redux';
import { default as thunkMiddleware } from 'redux-thunk';

import { resetSubscriptionForm } from './actions/index';
import SubscriptionFormContainer, { ISubscriptionFormContainerProps } from './component/subscription_form_container';
import subReducer, { ISubscriptionFormState } from './reducer/index';

let finalCreateStore = createStore;

finalCreateStore = applyMiddleware(
    thunkMiddleware
)(finalCreateStore);

export interface IComponentState {
  form: ISubscriptionFormState;
}

const getStore = () => finalCreateStore<IComponentState>(combineReducers<IComponentState>({
  form: subReducer,
}));

class SubscriptionForm extends React.Component<ISubscriptionFormContainerProps, void> {
  private store: Store<IComponentState>;

  public constructor(props: ISubscriptionFormContainerProps) {
    super(props);
    this.store = getStore();
  }
  public componentWillUnmount() {
    this.store.dispatch(resetSubscriptionForm({}));
  }
  public render() {
    return (
      <Provider store={this.store}>
        <SubscriptionFormContainer {...this.props} />
      </Provider>
    );
  }
}

export default SubscriptionForm;
export { ISubscriptionFormContainerProps };



// WEBPACK FOOTER //
// ./src/bundles/common/components/subscription_form/index.tsx